import { render, staticRenderFns } from "./NotificationsElement.vue?vue&type=template&id=313b180c&scoped=true"
import script from "./NotificationsElement.vue?vue&type=script&lang=js"
export * from "./NotificationsElement.vue?vue&type=script&lang=js"
import style0 from "./NotificationsElement.vue?vue&type=style&index=0&id=313b180c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b180c",
  null
  
)

export default component.exports